import { render } from "./gsrsu03030304.vue?vue&type=template&id=2ad768de&scoped=true"
import script from "./gsrsu03030304.vue?vue&type=script&lang=js"
export * from "./gsrsu03030304.vue?vue&type=script&lang=js"

import "./gsrsu03030304.vue?vue&type=style&index=0&id=2ad768de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad768de"]])

export default __exports__